import { MessageSquare, Scissors, Tag, UserCheck, Users } from "lucide-react";
import { i18n } from "@/lib/i18n";
import { NavigationItem } from "../types";

export const getNavigationItems = (): NavigationItem[] => {
  const t = i18n.getFixedT(null, "settings");

  return [
    {
      key: "customers",
      icon: Users,
      label: t("salonPage.navigation.customers.label"),
      description: t("salonPage.navigation.customers.description"),
      path: "/customers",
      show: false, // Hidden from Salon page
      variant: "primary",
    },
    {
      key: "workers",
      icon: UserCheck,
      label: t("salonPage.navigation.workers.label"),
      description: t("salonPage.navigation.workers.description"),
      path: "/workers",
      show: false, // Hidden from Salon page
      variant: "primary",
    },
    {
      key: "services",
      icon: Scissors,
      label: t("salonPage.navigation.services.label"),
      description: t("salonPage.navigation.services.description"),
      path: "/services",
      show: true,
      variant: "secondary", // Moved to secondary (Tools section)
    },
    {
      key: "discounts",
      icon: Tag,
      label: t("salonPage.navigation.discounts.label"),
      description: t("salonPage.navigation.discounts.description"),
      path: "/discounts",
      show: true,
      variant: "secondary",
    },
    {
      key: "messages",
      icon: MessageSquare,
      label: t("salonPage.navigation.messages.label"),
      description: t("salonPage.navigation.messages.description"),
      path: "/messages",
      show: false, // Hidden for now
      variant: "secondary",
    },
  ];
};

export const filterNavigationItems = (
  items: NavigationItem[],
  variant: "primary" | "secondary"
) => {
  return items.filter((item) => item.show && item.variant === variant);
};
